export const isNotValidateSize = (bytes: number, size = 500) => {
    const hundredMBInBytes = size * 1024 * 1024;
    return bytes > hundredMBInBytes;
};
